export class CartaMenu {
    idCarta: number;
    nombre: string;
    descripcion: string;
    imagen: string;
    fechaInicio: string; 
    fechaFin: string;
    horaInicio: string;
    horaFin: string;
    check: boolean;
    secciones?: ListaSecciones[];

    constructor(idCarta: number, nombre: string, descripcion :string, 
        imagen: string, fechaInicio: string, fechaFin: string,
        horaInicio: string, horaFin: string, check: boolean) {
        this.idCarta = idCarta;
        this.nombre = nombre;
        this.descripcion = descripcion;
        this.imagen = imagen;
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
        this.horaInicio = horaInicio;
        this.horaFin = horaFin;
        this.check = check;
      }
}

export interface Seccion {
    Pos: number;
    Edit: boolean;
    IdSeccion?: number;
    NombreSeccion: string;
    ColorSeccion: string;
    Platos?: Plato[];
    Menu:boolean;
    IconOn:string
    TipoItem: number;
    TipoSeccion: number
}

export interface ListaSecciones{
    loading?: boolean;
    numSecc: number;
    Secciones: Seccion[]
}
export interface Plato{
    IdPlato?: number;
    IDComercio: number;
    Nombre: string;
    Foto: string;
    Descripcion: string;
    NombredeFantasiaInterno: string;
    Orden: number;
    Checked: boolean;
    Precio: number;
    Liked: boolean;
    LanguageTransalate: string;
    Disponible: boolean
}
